import { t } from "ttag";

import {
  SettingsPageWrapper,
  SettingsSection,
} from "metabase/admin/components/SettingsSection";
import { usePageTitle } from "metabase/hooks/use-page-title";

import { CorsInputWidget } from "./CorsInputWidget";
import { SameSiteSelectWidget } from "./SameSiteSelectWidget";

export function EmbeddingSecuritySettings() {
  usePageTitle(t`Security`, { titleIndex: 1 });

  return (
    <SettingsPageWrapper title={t`Security`}>
      <SettingsSection>
        <CorsInputWidget />
      </SettingsSection>

      <SettingsSection>
        <SameSiteSelectWidget />
      </SettingsSection>
    </SettingsPageWrapper>
  );
}
